import React from "react";
import { Box, Grid } from "@material-ui/core";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { firebase } from "../../config/firebase/firebase-config";
import { AppState } from "../../redux/reducers/rootReducer";
import { CorrespondenceTable } from "../../components/correspondence-module/correspondence/CorrespondenceTable";
import { CustomizedSearch } from "../../components/custom/CustomizedSearch";
import AppAnimate from "../../components/ui/AppAnimate/AppAnimate";
import { CustomizedWindow } from "../../components/custom/CustomizedWindow";
import { SettledDetails } from "../../components/document-managment/correspondence/SettledDetails";
import moment from "moment";
import { uiCloseModalSee } from "../../redux/actions/uiActions";
import { setActiveCorrespondence } from "../../redux/actions/correspondenceActions";

export const EntitiesControlScreen = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const { modalSeeOpen } = useSelector((state: AppState) => state.ui);
  const { activeCorrespondence } = useSelector(
    (state: AppState) => state.documentManagment
  );
  const { correspondence: allCorrespondences } = useSelector(
    (state: AppState) => state.documentManagment
  );
  const correspondence = allCorrespondences.filter(
    (cor) =>
      cor.communicationType?.option === "Guardianship" ||
      cor.communicationType?.option === "IncidentOfContempt" ||
      cor.communicationType?.option === "CommunicationsControlEntities"
  );

  const date =
    activeCorrespondence?.createAt &&
    moment(
      (activeCorrespondence.createAt as firebase.firestore.Timestamp).toDate()
    ).format("YYYY/MM/DD - h:mm:ss");
  const onDeny = () => {
    dispatch(uiCloseModalSee());
    dispatch(setActiveCorrespondence(null));
  };

  return (
    <AppAnimate animation="transition.slideUpIn" delay={200}>
      <Box>
        <Box mb={3} fontSize={20}>
          <Grid container>
            <Grid item xs={7} />
            <Grid item xs={5}>
              <CustomizedSearch data={correspondence} />
            </Grid>
          </Grid>
        </Box>
        <CorrespondenceTable readOnly rows={correspondence} />
        <CustomizedWindow
          open={modalSeeOpen}
          content={<SettledDetails component="OTHER" />}
          onDeny={onDeny}
          title={`${intl.formatMessage({ id: "Settled" })} No. ${
            activeCorrespondence?.id
          } -  ${date}`}
        />
      </Box>
    </AppAnimate>
  );
};
